"use client";

import { useSearchContext } from "@/components/_Search/provider/SearchContextProvider";
import styles from "@/components/_Search/UI/SortAndFilter/FilterAndSort.module.scss";
import SelectInput from "@/components/UI/Input/SelectInput/SelectInput";
import { useScopedI18n } from "@/i18n/client";
import { PER_PAGE_VALUES } from "@/lib/_search-providers/constants";
import { FC } from "react";

const PageSize: FC = () => {
	const t = useScopedI18n("FilterAndSort");
	const { pageSize } = useSearchContext();

	const inputOptions = PER_PAGE_VALUES.map((value) => {
		return {
			text: String(value),
			value: String(value),
		};
	});

	const handleOnChange = (value: string) => {
		pageSize.setValue(value);
	};

	const label = t("itemsPerPage");
	return (
		<SelectInput
			label={label}
			placeHolder={label}
			options={inputOptions}
			value={String(pageSize.value)}
			prefix={`${label}: `}
			onChange={handleOnChange}
			className={styles.field}
		/>
	);
};

export default PageSize;
